import React, { useState } from 'react';
import { BsPlusLg } from 'react-icons/bs';
import { CgClose } from 'react-icons/cg';
import { MdOutlineQuiz } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { FiChevronRight } from 'react-icons/fi';

const ValentinesFAQ = () => {
  const [isActive, setIsActive] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="faqContainer">
      <div
        className="accordion-title d-flex justify-content-between align-items-center"
        onClick={() => setIsActive(!isActive)}
      >
        <div className="faq-container d-flex">
          <div className="faq-icon-contaner">
            <MdOutlineQuiz size={20} color="#040404" style={{ opacity: '0.5' }} />
          </div>
          <span className="faqTitle">FAQs</span>
        </div>
        <div className="col-1 d-flex justify-content-end">
          <span className="row toggleBtn">
            {isActive ? <CgClose color="#040404" size={20} /> : <BsPlusLg color="#040404" size={20} />}
          </span>
        </div>
      </div>
      {isActive && (
        <div className="accordion-content subText">
          <div>
            <ul className="termAndConditionPoints mt-4">
              <li>
                <p className="FAQ-Question" style={{ color: '#040404' }}>
                  What is the Five Years of GoSats campaign?
                </p>
                <p className="paragraph" style={{ color: '#040404', opacity: 0.5 }}>
                  The Five Years of GoSats campaign celebrates our 5th anniversary with exclusive benefits including Card Spend, Card Purchase and Gold Purchase rewards...
                </p>
              </li>
              <a
                style={{ color: '#D1964A', textDecoration: 'none', marginBottom: '0px' }}
                onClick={() => navigate('/valentinesFaq')}
                className="tAndc"
              >
                View more <FiChevronRight style={{ width: '18px', height: '18px', color: '#D1964A' }} className="back-button-icon" />
              </a>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default ValentinesFAQ;
